import { observer } from 'mobx-react-lite';
import React from 'react';
import { useNavigate } from 'react-router';
import { useStores, useTitle } from '../../common/hooks';
import './UserProfilePage.scss';

const UserProfilePageImpl: React.FC = () => {
  const {
    userStore,
  } = useStores();

  const navigate = useNavigate();

  useTitle('Partner Profile');
  
  return (
    <main className='user-profile-page'>
      <div
        className='header'
      >
        <h1>My profile</h1>
        <div
          className='button-group'
        >
          <button
            className='back-btn'
            onClick={() => navigate(-1)}
          >
            Back
          </button>
        </div>
      </div>
      <div 
        className='user-profile-content'
      >
      {
        userStore.userInfo ? (
          <>
          <span><b>{userStore.userInfo.firstName} {userStore.userInfo.lastName}</b> - {userStore.userInfo.email}</span>
          </>
        ) : (
          <span>No user found.</span>
        )
      }
      </div>
    </main>
  );
};

export const UserProfilePage = observer(UserProfilePageImpl);
